module.exports = __webpack_public_path__ + "static/media/segoeui-semibold.87bd68a4.woff2";